<template>
  <div ref="chartContainer" style="width: 100%; height: 100%;">
    <highcharts class="mt-4" :options="options"
     ref="aChart" style="width: 100%; height: 100%;"></highcharts>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'CycleTimeDurationInMin',
  props: {
    thisMachines: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.chart = this.$refs.aChart.chart;
    this.createSeries();
    this.initResizeObserver();
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  data() {
    return {
      resizeObserver: null,
      chart: null,
      options: {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, sans-serif',
          },
        },
        title: {
          text: 'CycleTime Duration (min)',
          style: {
            color: '',
          },
        },
        plotOptions: {
          series: {
            grouping: false,
            borderWidth: 0,
          },
        },
        legend: {
          enabled: true,
          align: 'center',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemStyle: {
            color: '#333',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          type: 'category',
          labels: {
            style: {
              color: '',
            },
          },
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: {
              style: {
                color: '',
              },
            },
          },
        ],
        series: [{}],
      },
    };
  },
  computed: {
    ...mapState('helper', ['isDark']),
    ...mapState('kpiDashboard', ['thisDate']),
  },
  methods: {
    roundOff(val) {
      if (val) {
        return Math.round((val + Number.EPSILON) * 100) / 100;
      }
      return 0;
    },
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.reflowChart();
      });
      if (this.$refs.chartContainer) {
        this.resizeObserver.observe(this.$refs.chartContainer);
      }
    },
    reflowChart() {
      this.$nextTick(() => {
        const chartInstance = this.$refs.aChart?.chart;
        if (chartInstance?.reflow) chartInstance.reflow();
      });
    },
    createSeries() {
      const data = this.thisMachines.map((m) => ({
        name: m.machinename,
        y: this.roundOff(m.a),
      }));
      const series = {
        color: this.isDark ? '#21C77C' : '#354493',
        id: 'main',
        data,
        name: `${this.thisDate}`,
      };
      this.options.series = [series];
      this.$nextTick(() => this.reflowChart()); // 👈 Trigger reflow
    },
  },
  watch: {
    thisMachines: {
      deep: true,
      handler() {
        this.createSeries();
      },
    },
    isDark: {
      immediate: true,
      handler(val) {
        const color = val ? '#FFFFFF' : '#333333';
        const labelColor = val ? '#FFFFFF' : '#666666';
        const seriesColor = val ? '#21C77C' : '#354493';

        this.options.title.style.color = color;
        this.options.yAxis[0].labels.style.color = labelColor;
        this.options.xAxis.labels.style.color = labelColor;
        if (this.options.series[0]) {
          this.options.series[0].color = seriesColor;
        }
      },
    },
  },
};
</script>
